import {PlaylistPlayerComponentBase} from '@app/player/playlist-player.component.base';
import {Component} from "@angular/core";

@Component({
    selector: 'siq-playlist-player',
    // tslint:disable:no-unused-css
    styles: [`
        :host {
            width: 100%;
            height: 100%;
            position: fixed;
        }

        .error-text {
            position: absolute;
            bottom: 10px;
            width: 100%;
            font-size: 20px;
            color: #F9BC15;
            background-color: black;
            text-align: center;
            z-index: 100;
        }
    `],
    template: `
        <ng-container *ngComponentOutlet="layoutComponentClass"></ng-container>
        <div class="error-text">{{ errorText }}</div>
    `,
})
export class PlaylistPlayerComponent extends PlaylistPlayerComponentBase {
}
